<button
    apx-button
    [ngClass]="ngClassObject"
    [variant]="theme"
    [type]="type"
    [class]="class"
    [disabled]="disabled"
    (click)="buttonClick($event)"
    [title]="title"
    [loading]="loading"
    porAddFeature
    [featureName]="featureName"
    [dynamicValue]="dynamicValue">
    @if (icon) {
    <mat-icon [class]="iconClass" [hidden]="loading">{{ icon }}</mat-icon>
    }
    <span [hidden]="loading"><ng-content></ng-content></span>
</button>
